var map = {
	"./Aprilia_RS.webp": 46313,
	"./Aprilia_RS_mobile.webp": 21368,
	"./Aprilia_SR.webp": 69823,
	"./Aprilia_SR_mobile.webp": 17318,
	"./Aprilia_SXR.webp": 78201,
	"./Aprilia_SXR_mobile.webp": 60392,
	"./Aston Martin_DB9.webp": 84491,
	"./Aston Martin_DB9_mobile.webp": 34306,
	"./Aston Martin_Rapide.webp": 77595,
	"./Aston Martin_Rapide_mobile.webp": 31410,
	"./Aston Martin_Vanquish.webp": 56291,
	"./Aston Martin_Vanquish_mobile.webp": 57466,
	"./Aston Martin_Vantage.webp": 9548,
	"./Aston Martin_Vantage_mobile.webp": 42067,
	"./Audi_A3.webp": 74201,
	"./Audi_A3_mobile.webp": 23240,
	"./Audi_A4.webp": 73184,
	"./Audi_A4_mobile.webp": 91095,
	"./Audi_A5.webp": 56227,
	"./Audi_A5_mobile.webp": 52730,
	"./Audi_A6.webp": 91330,
	"./Audi_A6_mobile.webp": 31465,
	"./Audi_A7.webp": 46893,
	"./Audi_A7_mobile.webp": 52732,
	"./Audi_A8 L.webp": 4864,
	"./Audi_A8 L_mobile.webp": 73559,
	"./Audi_A8.webp": 27780,
	"./Audi_A8_mobile.webp": 92587,
	"./Audi_Q2.webp": 99726,
	"./Audi_Q2_mobile.webp": 84533,
	"./Audi_Q3.webp": 95753,
	"./Audi_Q3_mobile.webp": 12408,
	"./Audi_Q5.webp": 61363,
	"./Audi_Q5_mobile.webp": 49674,
	"./Audi_Q7.webp": 78429,
	"./Audi_Q7_mobile.webp": 92428,
	"./Audi_Q8.webp": 72852,
	"./Audi_Q8_mobile.webp": 1179,
	"./Audi_R8.webp": 97599,
	"./Audi_R8_mobile.webp": 86342,
	"./Audi_RS3.webp": 79371,
	"./Audi_RS3_mobile.webp": 70946,
	"./Audi_RS5.webp": 20001,
	"./Audi_RS5_mobile.webp": 58480,
	"./Audi_S4.webp": 76974,
	"./Audi_S4_mobile.webp": 36629,
	"./Audi_TT.webp": 86977,
	"./Audi_TT_mobile.webp": 86672,
	"./Audi_e-tron.webp": 6892,
	"./Audi_e-tron_mobile.webp": 87699,
	"./BMW_1 Series.webp": 18758,
	"./BMW_1 Series_mobile.webp": 31629,
	"./BMW_2 Series.webp": 55353,
	"./BMW_2 Series_mobile.webp": 90024,
	"./BMW_3 Series GT.webp": 24175,
	"./BMW_3 Series GT_mobile.webp": 91030,
	"./BMW_3 Series.webp": 24828,
	"./BMW_3 Series_mobile.webp": 83811,
	"./BMW_5 Series GT.webp": 52821,
	"./BMW_5 Series GT_mobile.webp": 76708,
	"./BMW_5 Series.webp": 24874,
	"./BMW_5 Series_mobile.webp": 6641,
	"./BMW_6 Series GT.webp": 35080,
	"./BMW_6 Series GT_mobile.webp": 51103,
	"./BMW_6 Series.webp": 99997,
	"./BMW_6 Series_mobile.webp": 33740,
	"./BMW_7 Series.webp": 1632,
	"./BMW_7 Series_mobile.webp": 65943,
	"./BMW_G 310.webp": 47347,
	"./BMW_G 310_mobile.webp": 97546,
	"./BMW_M3.webp": 74678,
	"./BMW_M3_mobile.webp": 35357,
	"./BMW_M5.webp": 23384,
	"./BMW_M5_mobile.webp": 59023,
	"./BMW_X1.webp": 58745,
	"./BMW_X1_mobile.webp": 42952,
	"./BMW_X3.webp": 95007,
	"./BMW_X3_mobile.webp": 22790,
	"./BMW_X4.webp": 9666,
	"./BMW_X4_mobile.webp": 90025,
	"./BMW_X5.webp": 72685,
	"./BMW_X5_mobile.webp": 65948,
	"./BMW_X6.webp": 29600,
	"./BMW_X6_mobile.webp": 36791,
	"./BMW_X7.webp": 17091,
	"./BMW_X7_mobile.webp": 12922,
	"./BMW_Z4.webp": 37364,
	"./BMW_Z4_mobile.webp": 90139,
	"./BMW_i4.webp": 93855,
	"./BMW_i4_mobile.webp": 79334,
	"./BMW_iX.webp": 36651,
	"./BMW_iX_mobile.webp": 30178,
	"./BYD_e6.webp": 9314,
	"./BYD_e6_mobile.webp": 79305,
	"./Bajaj_Aspire.webp": 98760,
	"./Bajaj_Aspire_mobile.webp": 19231,
	"./Bajaj_Avenger.webp": 48720,
	"./Bajaj_Avenger_mobile.webp": 68199,
	"./Bajaj_CT.webp": 89269,
	"./Bajaj_CT_mobile.webp": 26404,
	"./Bajaj_Discover.webp": 47205,
	"./Bajaj_Discover_mobile.webp": 91732,
	"./Bajaj_Dominar.webp": 33670,
	"./Bajaj_Dominar_mobile.webp": 36909,
	"./Bajaj_Platina.webp": 50975,
	"./Bajaj_Platina_mobile.webp": 41446,
	"./Bajaj_Pulsar.webp": 3027,
	"./Bajaj_Pulsar_mobile.webp": 98026,
	"./Benelli_302.webp": 87548,
	"./Benelli_302_mobile.webp": 46915,
	"./Benelli_Imperiale.webp": 11539,
	"./Benelli_Imperiale_mobile.webp": 48650,
	"./Benelli_Leoncino.webp": 55504,
	"./Benelli_Leoncino_mobile.webp": 40231,
	"./Benelli_TNT.webp": 73485,
	"./Benelli_TNT_mobile.webp": 98236,
	"./Benelli_TRK.webp": 10632,
	"./Benelli_TRK_mobile.webp": 23679,
	"./Bentley_Continental.webp": 33802,
	"./Bentley_Continental_mobile.webp": 38385,
	"./Bentley_Flying Spur.webp": 68982,
	"./Bentley_Flying Spur_mobile.webp": 18653,
	"./Bentley_Mulsanne.webp": 1552,
	"./Bentley_Mulsanne_mobile.webp": 46599,
	"./Chevrolet_Aveo.webp": 89679,
	"./Chevrolet_Aveo_mobile.webp": 99254,
	"./Chevrolet_Beat.webp": 57960,
	"./Chevrolet_Beat_mobile.webp": 65983,
	"./Chevrolet_Captiva.webp": 33870,
	"./Chevrolet_Captiva_mobile.webp": 56437,
	"./Chevrolet_Cruze.webp": 66973,
	"./Chevrolet_Cruze_mobile.webp": 44460,
	"./Chevrolet_Enjoy.webp": 24803,
	"./Chevrolet_Enjoy_mobile.webp": 63258,
	"./Chevrolet_Forester.webp": 42546,
	"./Chevrolet_Forester_mobile.webp": 63673,
	"./Chevrolet_Optra Magnum.webp": 31317,
	"./Chevrolet_Optra Magnum_mobile.webp": 15556,
	"./Chevrolet_Optra SRV.webp": 41021,
	"./Chevrolet_Optra SRV_mobile.webp": 76556,
	"./Chevrolet_Optra.webp": 94428,
	"./Chevrolet_Optra_mobile.webp": 78627,
	"./Chevrolet_Sail Hatchback.webp": 54704,
	"./Chevrolet_Sail Hatchback_mobile.webp": 12679,
	"./Chevrolet_Sail.webp": 357,
	"./Chevrolet_Sail_mobile.webp": 33268,
	"./Chevrolet_Spark.webp": 56789,
	"./Chevrolet_Spark_mobile.webp": 5028,
	"./Chevrolet_Tavera.webp": 35375,
	"./Chevrolet_Tavera_mobile.webp": 16534,
	"./Chevrolet_Trailblazer.webp": 54690,
	"./Chevrolet_Trailblazer_mobile.webp": 77289,
	"./Chevrolet_UVA.webp": 34086,
	"./Chevrolet_UVA_mobile.webp": 63021,
	"./Citroen_C3.webp": 30562,
	"./Citroen_C3_mobile.webp": 25225,
	"./Citroen_C5 Aircross.webp": 13632,
	"./Citroen_C5 Aircross_mobile.webp": 22199,
	"./DC_Avanti.webp": 10458,
	"./DC_Avanti_mobile.webp": 47105,
	"./Daewoo_Cielo.webp": 48757,
	"./Daewoo_Cielo_mobile.webp": 49732,
	"./Daewoo_Matiz.webp": 20994,
	"./Daewoo_Matiz_mobile.webp": 16649,
	"./Daewoo_Nexia.webp": 14906,
	"./Daewoo_Nexia_mobile.webp": 96417,
	"./Datsun_GO Plus.webp": 8513,
	"./Datsun_GO Plus_mobile.webp": 26339,
	"./Datsun_GO.webp": 64887,
	"./Datsun_GO_mobile.webp": 71390,
	"./Datsun_Redi Go.webp": 86479,
	"./Datsun_Redi Go_mobile.webp": 61910,
	"./Ducati_Diavel.webp": 37947,
	"./Ducati_Diavel_mobile.webp": 30994,
	"./Ducati_Monster.webp": 51516,
	"./Ducati_Monster_mobile.webp": 82147,
	"./Ducati_Multistrada.webp": 29862,
	"./Ducati_Multistrada_mobile.webp": 5293,
	"./Ducati_Scrambler.webp": 3893,
	"./Ducati_Scrambler_mobile.webp": 38820,
	"./Escorts_Rajdoot.webp": 44618,
	"./Escorts_Rajdoot_mobile.webp": 11985,
	"./Fb Mondial_HPS.webp": 41279,
	"./Fb Mondial_HPS_mobile.webp": 26854,
	"./Ferrari_458 Italia.webp": 90462,
	"./Ferrari_458 Italia_mobile.webp": 76773,
	"./Ferrari_458 Speciale.webp": 62842,
	"./Ferrari_458 Speciale_mobile.webp": 1857,
	"./Ferrari_488.webp": 59309,
	"./Ferrari_488_mobile.webp": 91740,
	"./Ferrari_California.webp": 76521,
	"./Ferrari_California_mobile.webp": 59928,
	"./Ferrari_F12 Berlinetta.webp": 93446,
	"./Ferrari_F12 Berlinetta_mobile.webp": 86477,
	"./Ferrari_FF.webp": 44287,
	"./Ferrari_FF_mobile.webp": 46406,
	"./Fiat_Abarth Punto.webp": 76616,
	"./Fiat_Abarth Punto_mobile.webp": 82623,
	"./Fiat_Adventure.webp": 85786,
	"./Fiat_Adventure_mobile.webp": 53953,
	"./Fiat_Avventura.webp": 91200,
	"./Fiat_Avventura_mobile.webp": 55319,
	"./Fiat_Linea Classic.webp": 26031,
	"./Fiat_Linea Classic_mobile.webp": 60086,
	"./Fiat_Linea.webp": 54443,
	"./Fiat_Linea_mobile.webp": 27618,
	"./Fiat_Palio D.webp": 88479,
	"./Fiat_Palio D_mobile.webp": 70950,
	"./Fiat_Palio NV.webp": 62701,
	"./Fiat_Palio NV_mobile.webp": 72572,
	"./Fiat_Palio Stile.webp": 43422,
	"./Fiat_Palio Stile_mobile.webp": 40229,
	"./Fiat_Petra.webp": 83358,
	"./Fiat_Petra_mobile.webp": 67205,
	"./Fiat_Punto Evo.webp": 11200,
	"./Fiat_Punto Evo_mobile.webp": 74903,
	"./Fiat_Punto.webp": 54940,
	"./Fiat_Punto_mobile.webp": 19843,
	"./Fiat_Uno.webp": 95974,
	"./Fiat_Uno_mobile.webp": 12045,
	"./Fiat_Urban Cross.webp": 91070,
	"./Fiat_Urban Cross_mobile.webp": 41125,
	"./Force_Gurkha.webp": 75973,
	"./Force_Gurkha_mobile.webp": 94964,
	"./Force_One.webp": 81599,
	"./Force_One_mobile.webp": 31654,
	"./Force_Traveller 3350.webp": 56479,
	"./Force_Traveller 3350_mobile.webp": 7206,
	"./Force_Trax.webp": 42910,
	"./Force_Trax_mobile.webp": 61285,
	"./Ford_Eco Sport.webp": 36560,
	"./Ford_Eco Sport_mobile.webp": 6631,
	"./Ford_Endeavour.webp": 80472,
	"./Ford_Endeavour_mobile.webp": 95471,
	"./Ford_Escort.webp": 82329,
	"./Ford_Escort_mobile.webp": 4392,
	"./Ford_Fiesta Classic.webp": 48191,
	"./Ford_Fiesta Classic_mobile.webp": 55398,
	"./Ford_Fiesta.webp": 99643,
	"./Ford_Fiesta_mobile.webp": 84210,
	"./Ford_Figo Aspire.webp": 50948,
	"./Ford_Figo Aspire_mobile.webp": 84747,
	"./Ford_Figo.webp": 58738,
	"./Ford_Figo_mobile.webp": 6265,
	"./Ford_Freestyle.webp": 33900,
	"./Ford_Freestyle_mobile.webp": 90867,
	"./Ford_Fusion.webp": 78329,
	"./Ford_Fusion_mobile.webp": 55848,
	"./Ford_Ikon.webp": 68216,
	"./Ford_Ikon_mobile.webp": 10159,
	"./Ford_Mondeo.webp": 91907,
	"./Ford_Mondeo_mobile.webp": 36634,
	"./Ford_Mustang.webp": 77400,
	"./Ford_Mustang_mobile.webp": 13615,
	"./Harley Davidson_Fat Bob.webp": 23383,
	"./Harley Davidson_Fat Bob_mobile.webp": 37406,
	"./Harley Davidson_Forty Eight.webp": 40760,
	"./Harley Davidson_Forty Eight_mobile.webp": 7983,
	"./Harley Davidson_Heritage Classic.webp": 11184,
	"./Harley Davidson_Heritage Classic_mobile.webp": 80135,
	"./Harley Davidson_Iron.webp": 78083,
	"./Harley Davidson_Iron_mobile.webp": 10138,
	"./Harley Davidson_Low Rider.webp": 56533,
	"./Harley Davidson_Low Rider_mobile.webp": 50468,
	"./Harley Davidson_Road King.webp": 97590,
	"./Harley Davidson_Road King_mobile.webp": 57405,
	"./Harley Davidson_Sportster.webp": 18633,
	"./Harley Davidson_Sportster_mobile.webp": 52120,
	"./Harley Davidson_Street.webp": 6098,
	"./Harley Davidson_Street_mobile.webp": 20441,
	"./Harley Davidson_Super Low.webp": 91506,
	"./Harley Davidson_Super Low_mobile.webp": 54425,
	"./Hero_Achiever.webp": 38705,
	"./Hero_Achiever_mobile.webp": 49408,
	"./Hero_CD Deluxe.webp": 29924,
	"./Hero_CD Deluxe_mobile.webp": 28779,
	"./Hero_Destini.webp": 10056,
	"./Hero_Destini_mobile.webp": 28479,
	"./Hero_Duet.webp": 93832,
	"./Hero_Duet_mobile.webp": 24287,
	"./Hero_Glamour.webp": 243,
	"./Hero_Glamour_mobile.webp": 44266,
	"./Hero_HF Deluxe.webp": 62459,
	"./Hero_HF Deluxe_mobile.webp": 62194,
	"./Hero_HF.webp": 57788,
	"./Hero_HF_mobile.webp": 9539,
	"./Hero_Igniter.webp": 25658,
	"./Hero_Igniter_mobile.webp": 65185,
	"./Hero_Karizma.webp": 65661,
	"./Hero_Karizma_mobile.webp": 73676,
	"./Hero_Maestro.webp": 83483,
	"./Hero_Maestro_mobile.webp": 50962,
	"./Hero_Passion.webp": 96403,
	"./Hero_Passion_mobile.webp": 78730,
	"./Hero_Pleasure.webp": 28757,
	"./Hero_Pleasure_mobile.webp": 53508,
	"./Hero_Splendor.webp": 63273,
	"./Hero_Splendor_mobile.webp": 68632,
	"./Hero_Xpulse.webp": 58155,
	"./Hero_Xpulse_mobile.webp": 3682,
	"./Hero_Xtreme.webp": 6797,
	"./Hero_Xtreme_mobile.webp": 220,
	"./Hindustan Motors_Ambassador.webp": 50261,
	"./Hindustan Motors_Ambassador_mobile.webp": 80100,
	"./Honda_Accord Hybrid.webp": 76972,
	"./Honda_Accord Hybrid_mobile.webp": 98099,
	"./Honda_Accord.webp": 61006,
	"./Honda_Accord_mobile.webp": 37333,
	"./Honda_Activa.webp": 85548,
	"./Honda_Activa_mobile.webp": 39475,
	"./Honda_Amaze.webp": 14246,
	"./Honda_Amaze_mobile.webp": 77581,
	"./Honda_Aviator.webp": 33572,
	"./Honda_Aviator_mobile.webp": 42539,
	"./Honda_BRV.webp": 11876,
	"./Honda_BRV_mobile.webp": 50155,
	"./Honda_Brio.webp": 36854,
	"./Honda_Brio_mobile.webp": 82397,
	"./Honda_CB.webp": 5991,
	"./Honda_CB_mobile.webp": 83022,
	"./Honda_CD.webp": 86165,
	"./Honda_CD_mobile.webp": 24964,
	"./Honda_CRV.webp": 68459,
	"./Honda_CRV_mobile.webp": 39778,
	"./Honda_City IDTEC.webp": 20970,
	"./Honda_City IDTEC_mobile.webp": 98833,
	"./Honda_City IVTEC.webp": 89656,
	"./Honda_City IVTEC_mobile.webp": 53391,
	"./Honda_City ZX.webp": 31077,
	"./Honda_City ZX_mobile.webp": 9492,
	"./Honda_City.webp": 4981,
	"./Honda_City_mobile.webp": 79556,
	"./Honda_Civic.webp": 49716,
	"./Honda_Civic_mobile.webp": 93531,
	"./Honda_Dio.webp": 54802,
	"./Honda_Dio_mobile.webp": 16025,
	"./Honda_Dream.webp": 38197,
	"./Honda_Dream_mobile.webp": 99140,
	"./Honda_Grazia.webp": 48006,
	"./Honda_Grazia_mobile.webp": 60205,
	"./Honda_Hornet.webp": 29382,
	"./Honda_Hornet_mobile.webp": 92941,
	"./Honda_Jazz.webp": 96527,
	"./Honda_Jazz_mobile.webp": 89462,
	"./Honda_Livo.webp": 23286,
	"./Honda_Livo_mobile.webp": 46013,
	"./Honda_Mobilio.webp": 85837,
	"./Honda_Mobilio_mobile.webp": 54364,
	"./Honda_Navi.webp": 9558,
	"./Honda_Navi_mobile.webp": 91197,
	"./Honda_SP.webp": 50785,
	"./Honda_SP_mobile.webp": 26000,
	"./Honda_Shine.webp": 9909,
	"./Honda_Shine_mobile.webp": 87492,
	"./Honda_Unicorn.webp": 16202,
	"./Honda_Unicorn_mobile.webp": 7409,
	"./Honda_WRV.webp": 76567,
	"./Honda_WRV_mobile.webp": 83070,
	"./Honda_X-Blade.webp": 21749,
	"./Honda_X-Blade_mobile.webp": 89828,
	"./Hummer_H2.webp": 48522,
	"./Hummer_H2_mobile.webp": 28817,
	"./Hummer_H3.webp": 94037,
	"./Hummer_H3_mobile.webp": 57668,
	"./Husqvarna_Svartpilen.webp": 45751,
	"./Husqvarna_Svartpilen_mobile.webp": 3838,
	"./Husqvarna_Vitpilen.webp": 21840,
	"./Husqvarna_Vitpilen_mobile.webp": 46887,
	"./Hyosung_Aquila.webp": 55758,
	"./Hyosung_Aquila_mobile.webp": 43317,
	"./Hyosung_GT.webp": 99214,
	"./Hyosung_GT_mobile.webp": 2101,
	"./Hyosung_ST.webp": 57298,
	"./Hyosung_ST_mobile.webp": 15897,
	"./Hyundai_Accent Viva.webp": 96148,
	"./Hyundai_Accent Viva_mobile.webp": 16507,
	"./Hyundai_Accent.webp": 68056,
	"./Hyundai_Accent_mobile.webp": 25967,
	"./Hyundai_Alcazar.webp": 87620,
	"./Hyundai_Alcazar_mobile.webp": 17899,
	"./Hyundai_Aura.webp": 48953,
	"./Hyundai_Aura_mobile.webp": 14280,
	"./Hyundai_Creta.webp": 37689,
	"./Hyundai_Creta_mobile.webp": 8360,
	"./Hyundai_Elantra.webp": 52433,
	"./Hyundai_Elantra_mobile.webp": 71008,
	"./Hyundai_Elite i20.webp": 4008,
	"./Hyundai_Elite i20_mobile.webp": 76895,
	"./Hyundai_Eon.webp": 92684,
	"./Hyundai_Eon_mobile.webp": 51187,
	"./Hyundai_Getz Prime.webp": 68980,
	"./Hyundai_Getz Prime_mobile.webp": 21070,
	"./Hyundai_Getz.webp": 81520,
	"./Hyundai_Getz_mobile.webp": 22023,
	"./Hyundai_Grand i10 Nios.webp": 23301,
	"./Hyundai_Grand i10 Nios_mobile.webp": 25492,
	"./Hyundai_Grand i10.webp": 57978,
	"./Hyundai_Grand i10_mobile.webp": 50145,
	"./Hyundai_Kona.webp": 1293,
	"./Hyundai_Kona_mobile.webp": 19580,
	"./Hyundai_SantaFE.webp": 69850,
	"./Hyundai_SantaFE_mobile.webp": 46881,
	"./Hyundai_Santro Xing.webp": 23249,
	"./Hyundai_Santro Xing_mobile.webp": 87392,
	"./Hyundai_Santro.webp": 58027,
	"./Hyundai_Santro_mobile.webp": 92482,
	"./Hyundai_Sonata Embera.webp": 26172,
	"./Hyundai_Sonata Embera_mobile.webp": 47171,
	"./Hyundai_Sonata Transform.webp": 21474,
	"./Hyundai_Sonata Transform_mobile.webp": 79273,
	"./Hyundai_Sonata.webp": 50518,
	"./Hyundai_Sonata_mobile.webp": 3933,
	"./Hyundai_Tucson.webp": 46214,
	"./Hyundai_Tucson_mobile.webp": 23949,
	"./Hyundai_Venue N Line.webp": 69227,
	"./Hyundai_Venue N Line_mobile.webp": 68706,
	"./Hyundai_Venue.webp": 56449,
	"./Hyundai_Venue_mobile.webp": 33072,
	"./Hyundai_Verna Fluidic.webp": 68634,
	"./Hyundai_Verna Fluidic_mobile.webp": 9569,
	"./Hyundai_Verna Transform.webp": 12222,
	"./Hyundai_Verna Transform_mobile.webp": 26053,
	"./Hyundai_Verna.webp": 79162,
	"./Hyundai_Verna_mobile.webp": 3297,
	"./Hyundai_Xcent.webp": 73656,
	"./Hyundai_Xcent_mobile.webp": 21167,
	"./Hyundai_i10.webp": 60140,
	"./Hyundai_i10_mobile.webp": 7763,
	"./Hyundai_i20 Active.webp": 5455,
	"./Hyundai_i20 Active_mobile.webp": 33398,
	"./Hyundai_i20 N Line.webp": 86797,
	"./Hyundai_i20 N Line_mobile.webp": 2108,
	"./Hyundai_i20.webp": 69447,
	"./Hyundai_i20_mobile.webp": 26702,
	"./Indian_Scout.webp": 27199,
	"./Indian_Scout_mobile.webp": 82982,
	"./Isuzu_Dmax V Cross.webp": 84698,
	"./Isuzu_Dmax V Cross_mobile.webp": 353,
	"./Isuzu_MU-X.webp": 14237,
	"./Isuzu_MU-X_mobile.webp": 50284,
	"./Isuzu_MU7.webp": 15253,
	"./Isuzu_MU7_mobile.webp": 12484,
	"./Jaguar_F Pace.webp": 29377,
	"./Jaguar_F Pace_mobile.webp": 23216,
	"./Jaguar_F Type.webp": 82190,
	"./Jaguar_F Type_mobile.webp": 82133,
	"./Jaguar_I-Pace.webp": 13229,
	"./Jaguar_I-Pace_mobile.webp": 21116,
	"./Jaguar_XE.webp": 33755,
	"./Jaguar_XE_mobile.webp": 29234,
	"./Jaguar_XF.webp": 46906,
	"./Jaguar_XF_mobile.webp": 15425,
	"./Jaguar_XJ.webp": 42062,
	"./Jaguar_XJR.webp": 51680,
	"./Jaguar_XJR_mobile.webp": 24439,
	"./Jaguar_XJ_mobile.webp": 24117,
	"./Jaguar_XK R.webp": 5975,
	"./Jaguar_XK R_mobile.webp": 28894,
	"./Jawa_Classic.webp": 41623,
	"./Jawa_Classic_mobile.webp": 7934,
	"./Jawa_Forty Two.webp": 79641,
	"./Jawa_Forty Two_mobile.webp": 19240,
	"./Jawa_Perak.webp": 98840,
	"./Jawa_Perak_mobile.webp": 83119,
	"./Jawa_Standard.webp": 88140,
	"./Jawa_Standard_mobile.webp": 15507,
	"./Jayem_Neo.webp": 59336,
	"./Jayem_Neo_mobile.webp": 57951,
	"./Jeep_Compass.webp": 62202,
	"./Jeep_Compass_mobile.webp": 46401,
	"./KTM_Adventure.webp": 48666,
	"./KTM_Adventure_mobile.webp": 91713,
	"./KTM_Duke.webp": 33273,
	"./KTM_Duke_mobile.webp": 78920,
	"./KTM_RC.webp": 42085,
	"./KTM_RC_mobile.webp": 57396,
	"./Kawasaki_ER.webp": 17549,
	"./Kawasaki_ER_mobile.webp": 46204,
	"./Kawasaki_KLX.webp": 66507,
	"./Kawasaki_KLX_mobile.webp": 5250,
	"./Kawasaki_KX.webp": 72793,
	"./Kawasaki_KX_mobile.webp": 64104,
	"./Kawasaki_Ninja.webp": 33806,
	"./Kawasaki_Ninja_mobile.webp": 34005,
	"./Kawasaki_Versys.webp": 91324,
	"./Kawasaki_Versys_mobile.webp": 14403,
	"./Kawasaki_Vulcan.webp": 20861,
	"./Kawasaki_Vulcan_mobile.webp": 98828,
	"./Kawasaki_Z.webp": 92228,
	"./Kawasaki_Z_mobile.webp": 47467,
	"./Kia_Carens.webp": 73131,
	"./Kia_Carens_mobile.webp": 22690,
	"./Kia_Carnival.webp": 54743,
	"./Kia_Carnival_mobile.webp": 94910,
	"./Kia_EV6.webp": 32712,
	"./Kia_EV6_mobile.webp": 8927,
	"./Kia_Seltos.webp": 73019,
	"./Kia_Seltos_mobile.webp": 23250,
	"./Kia_Sonet.webp": 78658,
	"./Kia_Sonet_mobile.webp": 48905,
	"./Kinetic_Boss.webp": 72644,
	"./Kinetic_Boss_mobile.webp": 81451,
	"./LML_Freedom.webp": 38759,
	"./LML_Freedom_mobile.webp": 97198,
	"./Lamborghini_Aventador.webp": 52348,
	"./Lamborghini_Aventador_mobile.webp": 61507,
	"./Lamborghini_Gallardo.webp": 22642,
	"./Lamborghini_Gallardo_mobile.webp": 72601,
	"./Lamborghini_Huracan.webp": 43692,
	"./Lamborghini_Huracan_mobile.webp": 76883,
	"./Lamborghini_Urus.webp": 28691,
	"./Lamborghini_Urus_mobile.webp": 53706,
	"./Land Rover_Defender.webp": 28266,
	"./Land Rover_Defender_mobile.webp": 33809,
	"./Land Rover_Discovery 4.webp": 129,
	"./Land Rover_Discovery 4_mobile.webp": 40880,
	"./Land Rover_Discovery Sport.webp": 48275,
	"./Land Rover_Discovery Sport_mobile.webp": 80138,
	"./Land Rover_Freelander 2.webp": 77615,
	"./Land Rover_Freelander 2_mobile.webp": 66422,
	"./Land Rover_Range Rover Evoque.webp": 96215,
	"./Land Rover_Range Rover Evoque_mobile.webp": 19614,
	"./Land Rover_Range Rover Sport.webp": 29784,
	"./Land Rover_Range Rover Sport_mobile.webp": 5487,
	"./Land Rover_Range Rover Velar.webp": 72050,
	"./Land Rover_Range Rover Velar_mobile.webp": 68217,
	"./Land Rover_Range Rover Vogue.webp": 27052,
	"./Land Rover_Range Rover Vogue_mobile.webp": 33363,
	"./Land Rover_Range Rover.webp": 53126,
	"./Land Rover_Range Rover_mobile.webp": 75277,
	"./Lexus_ES.webp": 51527,
	"./Lexus_ES_mobile.webp": 94798,
	"./Lexus_LC.webp": 93234,
	"./Lexus_LC_mobile.webp": 72441,
	"./Lexus_LS.webp": 71618,
	"./Lexus_LS_mobile.webp": 30665,
	"./Lexus_LX.webp": 33771,
	"./Lexus_LX_mobile.webp": 77954,
	"./Lexus_NX.webp": 35549,
	"./Lexus_NX_mobile.webp": 10956,
	"./Lexus_RX.webp": 17897,
	"./Lexus_RX_mobile.webp": 80856,
	"./MG_Astor.webp": 64555,
	"./MG_Astor_mobile.webp": 52834,
	"./MG_Gloster.webp": 52434,
	"./MG_Gloster_mobile.webp": 58905,
	"./MG_Hector Plus.webp": 58645,
	"./MG_Hector Plus_mobile.webp": 54660,
	"./MG_Hector.webp": 54867,
	"./MG_Hector_mobile.webp": 43850,
	"./MG_ZS EV.webp": 5084,
	"./MG_ZS EV_mobile.webp": 47587,
	"./Mahindra_Alturas G4.webp": 53467,
	"./Mahindra_Alturas G4_mobile.webp": 10706,
	"./Mahindra_Bolero Camper.webp": 86375,
	"./Mahindra_Bolero Camper_mobile.webp": 89230,
	"./Mahindra_Bolero Neo.webp": 72417,
	"./Mahindra_Bolero Neo_mobile.webp": 52560,
	"./Mahindra_Bolero Pickup.webp": 4437,
	"./Mahindra_Bolero Pickup_mobile.webp": 83940,
	"./Mahindra_Bolero.webp": 93779,
	"./Mahindra_Bolero_mobile.webp": 65226,
	"./Mahindra_Centuro.webp": 93918,
	"./Mahindra_Centuro_mobile.webp": 97477,
	"./Mahindra_Duro.webp": 17428,
	"./Mahindra_Duro_mobile.webp": 9755,
	"./Mahindra_E20 Plus.webp": 18483,
	"./Mahindra_E20 Plus_mobile.webp": 72554,
	"./Mahindra_Gusto.webp": 93672,
	"./Mahindra_Gusto_mobile.webp": 88351,
	"./Mahindra_Imperio .webp": 61447,
	"./Mahindra_Imperio _mobile.webp": 34286,
	"./Mahindra_KUV 100.webp": 73309,
	"./Mahindra_KUV 100_mobile.webp": 65900,
	"./Mahindra_Logan.webp": 6145,
	"./Mahindra_Logan_mobile.webp": 66736,
	"./Mahindra_Marazzo.webp": 7164,
	"./Mahindra_Marazzo_mobile.webp": 80675,
	"./Mahindra_Mojo.webp": 75691,
	"./Mahindra_Mojo_mobile.webp": 76418,
	"./Mahindra_NuvoSport.webp": 71772,
	"./Mahindra_NuvoSport_mobile.webp": 99459,
	"./Mahindra_Pantero.webp": 3167,
	"./Mahindra_Pantero_mobile.webp": 86886,
	"./Mahindra_Quanto.webp": 85044,
	"./Mahindra_Quanto_mobile.webp": 94907,
	"./Mahindra_Reva.webp": 34132,
	"./Mahindra_Reva_mobile.webp": 63099,
	"./Mahindra_Saluto.webp": 30410,
	"./Mahindra_Saluto_mobile.webp": 53617,
	"./Mahindra_Scorpio Getaway.webp": 75943,
	"./Mahindra_Scorpio Getaway_mobile.webp": 19374,
	"./Mahindra_Scorpio N.webp": 85459,
	"./Mahindra_Scorpio N_mobile.webp": 82250,
	"./Mahindra_Scorpio.webp": 25657,
	"./Mahindra_Scorpio_mobile.webp": 77512,
	"./Mahindra_Stallio.webp": 96830,
	"./Mahindra_Stallio_mobile.webp": 89093,
	"./Mahindra_TUV 300 Plus.webp": 61598,
	"./Mahindra_TUV 300 Plus_mobile.webp": 57125,
	"./Mahindra_TUV 300.webp": 71518,
	"./Mahindra_TUV 300_mobile.webp": 71781,
	"./Mahindra_Thar.webp": 39591,
	"./Mahindra_Thar_mobile.webp": 9646,
	"./Mahindra_Verito Vibe CS.webp": 88855,
	"./Mahindra_Verito Vibe CS_mobile.webp": 83934,
	"./Mahindra_Verito.webp": 87569,
	"./Mahindra_Verito_mobile.webp": 25696,
	"./Mahindra_XUV 300.webp": 75450,
	"./Mahindra_XUV 300_mobile.webp": 75553,
	"./Mahindra_XUV 500.webp": 90020,
	"./Mahindra_XUV 500_mobile.webp": 42347,
	"./Mahindra_XUV 700.webp": 67990,
	"./Mahindra_XUV 700_mobile.webp": 57021,
	"./Mahindra_Xylo.webp": 82362,
	"./Mahindra_Xylo_mobile.webp": 10817,
	"./Maruti Suzuki_800.webp": 45293,
	"./Maruti Suzuki_800_mobile.webp": 52540,
	"./Maruti Suzuki_A-Star.webp": 95401,
	"./Maruti Suzuki_A-Star_mobile.webp": 69560,
	"./Maruti Suzuki_Alto 800.webp": 61899,
	"./Maruti Suzuki_Alto 800_mobile.webp": 3362,
	"./Maruti Suzuki_Alto K10.webp": 4855,
	"./Maruti Suzuki_Alto K10_mobile.webp": 46014,
	"./Maruti Suzuki_Alto.webp": 61331,
	"./Maruti Suzuki_Alto_mobile.webp": 93866,
	"./Maruti Suzuki_Baleno.webp": 40362,
	"./Maruti Suzuki_Baleno_mobile.webp": 73809,
	"./Maruti Suzuki_Celerio.webp": 6830,
	"./Maruti Suzuki_Celerio_mobile.webp": 17845,
	"./Maruti Suzuki_Ciaz.webp": 89036,
	"./Maruti Suzuki_Ciaz_mobile.webp": 38259,
	"./Maruti Suzuki_Eeco.webp": 83247,
	"./Maruti Suzuki_Eeco_mobile.webp": 1494,
	"./Maruti Suzuki_Ertiga.webp": 74043,
	"./Maruti Suzuki_Ertiga_mobile.webp": 66322,
	"./Maruti Suzuki_Esteem.webp": 96786,
	"./Maruti Suzuki_Esteem_mobile.webp": 85785,
	"./Maruti Suzuki_Estilo.webp": 86553,
	"./Maruti Suzuki_Estilo_mobile.webp": 14568,
	"./Maruti Suzuki_Grand Vitara.webp": 45570,
	"./Maruti Suzuki_Grand Vitara_mobile.webp": 4137,
	"./Maruti Suzuki_Ignis.webp": 29971,
	"./Maruti Suzuki_Ignis_mobile.webp": 49386,
	"./Maruti Suzuki_Kizashi.webp": 88100,
	"./Maruti Suzuki_Kizashi_mobile.webp": 45387,
	"./Maruti Suzuki_New Grand Vitara.webp": 1720,
	"./Maruti Suzuki_New Grand Vitara_mobile.webp": 33263,
	"./Maruti Suzuki_Omni.webp": 34918,
	"./Maruti Suzuki_Omni_mobile.webp": 18349,
	"./Maruti Suzuki_Ritz.webp": 62900,
	"./Maruti Suzuki_Ritz_mobile.webp": 59355,
	"./Maruti Suzuki_S-Cross.webp": 23121,
	"./Maruti Suzuki_S-Cross_mobile.webp": 14048,
	"./Maruti Suzuki_S-Presso.webp": 35939,
	"./Maruti Suzuki_S-Presso_mobile.webp": 15834,
	"./Maruti Suzuki_SX4.webp": 15204,
	"./Maruti Suzuki_SX4_mobile.webp": 20587,
	"./Maruti Suzuki_Swift Dzire.webp": 28798,
	"./Maruti Suzuki_Swift Dzire_mobile.webp": 43845,
	"./Maruti Suzuki_Swift.webp": 39754,
	"./Maruti Suzuki_Swift_mobile.webp": 36657,
	"./Maruti Suzuki_Versa.webp": 91572,
	"./Maruti Suzuki_Versa_mobile.webp": 78907,
	"./Maruti Suzuki_Vitara Brezza.webp": 30242,
	"./Maruti Suzuki_Vitara Brezza_mobile.webp": 41257,
	"./Maruti Suzuki_WagonR.webp": 9501,
	"./Maruti Suzuki_WagonR_mobile.webp": 39948,
	"./Maruti Suzuki_XL6.webp": 99155,
	"./Maruti Suzuki_XL6_mobile.webp": 36682,
	"./Maruti Suzuki_Zen.webp": 39348,
	"./Maruti Suzuki_Zen_mobile.webp": 53915,
	"./Maserati_Ghibli.webp": 67617,
	"./Maserati_Ghibli_mobile.webp": 58160,
	"./Maserati_GranCabrio.webp": 38640,
	"./Maserati_GranCabrio_mobile.webp": 34311,
	"./Maserati_GranTurismo.webp": 97491,
	"./Maserati_GranTurismo_mobile.webp": 55498,
	"./Maserati_Quattroporte.webp": 21770,
	"./Maserati_Quattroporte_mobile.webp": 59633,
	"./Mercedes_A-Class.webp": 25440,
	"./Mercedes_A-Class_mobile.webp": 43063,
	"./Mercedes_AMG GT.webp": 24124,
	"./Mercedes_AMG GT_mobile.webp": 37571,
	"./Mercedes_B-Class.webp": 49649,
	"./Mercedes_B-Class_mobile.webp": 16000,
	"./Mercedes_C-Class.webp": 16450,
	"./Mercedes_C-Class_mobile.webp": 66345,
	"./Mercedes_CLA Class.webp": 30448,
	"./Mercedes_CLA Class_mobile.webp": 56999,
	"./Mercedes_CLS Class.webp": 38286,
	"./Mercedes_CLS Class_mobile.webp": 37941,
	"./Mercedes_E-Class.webp": 77476,
	"./Mercedes_E-Class_mobile.webp": 3467,
	"./Mercedes_EQC.webp": 42845,
	"./Mercedes_EQC_mobile.webp": 47052,
	"./Mercedes_EQS.webp": 24397,
	"./Mercedes_EQS_mobile.webp": 49084,
	"./Mercedes_G63 AMGr.webp": 53571,
	"./Mercedes_G63 AMGr_mobile.webp": 71322,
	"./Mercedes_GL Class.webp": 16189,
	"./Mercedes_GL Class_mobile.webp": 10988,
	"./Mercedes_GLA Class.webp": 5908,
	"./Mercedes_GLA Class_mobile.webp": 74715,
	"./Mercedes_GLC.webp": 34478,
	"./Mercedes_GLC_mobile.webp": 37525,
	"./Mercedes_GLE Class.webp": 53744,
	"./Mercedes_GLE Class_mobile.webp": 59303,
	"./Mercedes_GLE43 AMG.webp": 22098,
	"./Mercedes_GLE43 AMG_mobile.webp": 1977,
	"./Mercedes_GLS.webp": 41182,
	"./Mercedes_GLS_mobile.webp": 39941,
	"./Mercedes_ML Class.webp": 97991,
	"./Mercedes_ML Class_mobile.webp": 95630,
	"./Mercedes_R Class.webp": 27964,
	"./Mercedes_R Class_mobile.webp": 52099,
	"./Mercedes_S-Class.webp": 42610,
	"./Mercedes_S-Class_mobile.webp": 26617,
	"./Mercedes_SL 500 AMG.webp": 51785,
	"./Mercedes_SL 500 AMG_mobile.webp": 16984,
	"./Mercedes_SLK Class.webp": 72742,
	"./Mercedes_SLK Class_mobile.webp": 53869,
	"./Mercedes_V-Class.webp": 17749,
	"./Mercedes_V-Class_mobile.webp": 35044,
	"./Mini_Clubman.webp": 20857,
	"./Mini_Clubman_mobile.webp": 66312,
	"./Mini_Cooper SE.webp": 70419,
	"./Mini_Cooper SE_mobile.webp": 49194,
	"./Mini_Cooper.webp": 23489,
	"./Mini_Cooper_mobile.webp": 752,
	"./Mini_Countryman.webp": 22569,
	"./Mini_Countryman_mobile.webp": 89464,
	"./Mitsubishi_Cedia.webp": 49995,
	"./Mitsubishi_Cedia_mobile.webp": 51458,
	"./Mitsubishi_Lancer.webp": 26740,
	"./Mitsubishi_Lancer_mobile.webp": 66875,
	"./Mitsubishi_Montero.webp": 78955,
	"./Mitsubishi_Montero_mobile.webp": 83394,
	"./Mitsubishi_Outlander.webp": 24163,
	"./Mitsubishi_Outlander_mobile.webp": 96890,
	"./Mitsubishi_Pajero Sport.webp": 47179,
	"./Mitsubishi_Pajero Sport_mobile.webp": 76719,
	"./Mitsubishi_Pajero.webp": 81062,
	"./Mitsubishi_Pajero_mobile.webp": 35181,
	"./Nissan_Evalia.webp": 44906,
	"./Nissan_Evalia_mobile.webp": 50673,
	"./Nissan_GTR.webp": 31929,
	"./Nissan_GTR_mobile.webp": 32584,
	"./Nissan_Kicks.webp": 1365,
	"./Nissan_Kicks_mobile.webp": 94692,
	"./Nissan_Magnite.webp": 35411,
	"./Nissan_Magnite_mobile.webp": 67530,
	"./Nissan_Micra Active.webp": 59334,
	"./Nissan_Micra Active_mobile.webp": 61069,
	"./Nissan_Micra.webp": 38024,
	"./Nissan_Micra_mobile.webp": 26431,
	"./Nissan_Sunny.webp": 63885,
	"./Nissan_Sunny_mobile.webp": 95420,
	"./Nissan_Teana.webp": 61581,
	"./Nissan_Teana_mobile.webp": 87772,
	"./Nissan_Terrano.webp": 59847,
	"./Nissan_Terrano_mobile.webp": 814,
	"./Nissan_X-Trail.webp": 46403,
	"./Nissan_X-Trail_mobile.webp": 46074,
	"./Opel_Astra.webp": 78421,
	"./Opel_Astra_mobile.webp": 11940,
	"./Opel_Corsa.webp": 82440,
	"./Opel_Corsa_mobile.webp": 43775,
	"./Photon_VIW CS2.webp": 96882,
	"./Photon_VIW CS2_mobile.webp": 79129,
	"./Porsche_911.webp": 73233,
	"./Porsche_911_mobile.webp": 35168,
	"./Porsche_Boxter.webp": 57772,
	"./Porsche_Boxter_mobile.webp": 16595,
	"./Porsche_Cayenne.webp": 47085,
	"./Porsche_Cayenne_mobile.webp": 40476,
	"./Porsche_Cayman.webp": 18841,
	"./Porsche_Cayman_mobile.webp": 65928,
	"./Porsche_Macan.webp": 26736,
	"./Porsche_Macan_mobile.webp": 51079,
	"./Porsche_Panamera.webp": 28193,
	"./Porsche_Panamera_mobile.webp": 95792,
	"./Porsche_Taycan Turismo.webp": 96811,
	"./Porsche_Taycan Turismo_mobile.webp": 86594,
	"./Porsche_Taycan.webp": 69968,
	"./Porsche_Taycan_mobile.webp": 29703,
	"./Premier_Rio.webp": 99846,
	"./Premier_Rio_mobile.webp": 56941,
	"./Renault_Captur.webp": 93402,
	"./Renault_Captur_mobile.webp": 10561,
	"./Renault_Duster.webp": 93490,
	"./Renault_Duster_mobile.webp": 47993,
	"./Renault_Fluence.webp": 33841,
	"./Renault_Fluence_mobile.webp": 87072,
	"./Renault_Kiger.webp": 27713,
	"./Renault_Kiger_mobile.webp": 74384,
	"./Renault_Koleos.webp": 3138,
	"./Renault_Koleos_mobile.webp": 809,
	"./Renault_Kwid.webp": 76334,
	"./Renault_Kwid_mobile.webp": 59733,
	"./Renault_Lodgy.webp": 31212,
	"./Renault_Lodgy_mobile.webp": 99315,
	"./Renault_Pulse.webp": 87914,
	"./Renault_Pulse_mobile.webp": 7281,
	"./Renault_Scala.webp": 47161,
	"./Renault_Scala_mobile.webp": 74952,
	"./Renault_Triber.webp": 50275,
	"./Renault_Triber_mobile.webp": 37690,
	"./Rolls Royce_Ghost.webp": 95237,
	"./Rolls Royce_Ghost_mobile.webp": 45300,
	"./Rolls Royce_Phantom.webp": 3923,
	"./Rolls Royce_Phantom_mobile.webp": 45354,
	"./Rolls Royce_Wraith.webp": 39209,
	"./Rolls Royce_Wraith_mobile.webp": 81752,
	"./Royal Enfield_Bullet.webp": 9714,
	"./Royal Enfield_Bullet_mobile.webp": 83545,
	"./Royal Enfield_Classic.webp": 46450,
	"./Royal Enfield_Classic_mobile.webp": 39545,
	"./Royal Enfield_Continental.webp": 73299,
	"./Royal Enfield_Continental_mobile.webp": 9738,
	"./Royal Enfield_Electra.webp": 37636,
	"./Royal Enfield_Electra_mobile.webp": 85227,
	"./Royal Enfield_Himalayan.webp": 24452,
	"./Royal Enfield_Himalayan_mobile.webp": 79339,
	"./Royal Enfield_Hunter.webp": 14920,
	"./Royal Enfield_Hunter_mobile.webp": 60575,
	"./Royal Enfield_Interceptor.webp": 30689,
	"./Royal Enfield_Interceptor_mobile.webp": 86704,
	"./Royal Enfield_Meteor.webp": 44174,
	"./Royal Enfield_Meteor_mobile.webp": 51138,
	"./Royal Enfield_Scram.webp": 90776,
	"./Royal Enfield_Scram_mobile.webp": 1263,
	"./Royal Enfield_Standard.webp": 6611,
	"./Royal Enfield_Standard_mobile.webp": 22762,
	"./Royal Enfield_Thunderbird.webp": 13915,
	"./Royal Enfield_Thunderbird_mobile.webp": 8613,
	"./Skoda_Fabia Scout.webp": 75381,
	"./Skoda_Fabia Scout_mobile.webp": 55268,
	"./Skoda_Fabia.webp": 29203,
	"./Skoda_Fabia_mobile.webp": 43306,
	"./Skoda_Kodiaq.webp": 16131,
	"./Skoda_Kodiaq_mobile.webp": 41466,
	"./Skoda_Kushaq.webp": 67957,
	"./Skoda_Kushaq_mobile.webp": 60516,
	"./Skoda_Laura.webp": 75543,
	"./Skoda_Laura_mobile.webp": 77278,
	"./Skoda_Octavia.webp": 98383,
	"./Skoda_Octavia_mobile.webp": 37110,
	"./Skoda_Rapid.webp": 23246,
	"./Skoda_Rapid_mobile.webp": 46581,
	"./Skoda_Slavia.webp": 11550,
	"./Skoda_Slavia_mobile.webp": 2949,
	"./Skoda_Superb.webp": 43347,
	"./Skoda_Superb_mobile.webp": 16618,
	"./Skoda_Yeti.webp": 30389,
	"./Skoda_Yeti_mobile.webp": 28567,
	"./Ssangyong_Rexton.webp": 48491,
	"./Ssangyong_Rexton_mobile.webp": 81090,
	"./Suzuki_Access.webp": 52375,
	"./Suzuki_Access_mobile.webp": 45246,
	"./Suzuki_Avenis.webp": 16821,
	"./Suzuki_Avenis_mobile.webp": 32836,
	"./Suzuki_Burgman.webp": 3045,
	"./Suzuki_Burgman_mobile.webp": 10260,
	"./Suzuki_Fiero.webp": 79476,
	"./Suzuki_Fiero_mobile.webp": 32955,
	"./Suzuki_GS.webp": 14211,
	"./Suzuki_GSX-R.webp": 61062,
	"./Suzuki_GSX-R_mobile.webp": 27245,
	"./Suzuki_GS_mobile.webp": 33210,
	"./Suzuki_Gixxer.webp": 30142,
	"./Suzuki_Gixxer_mobile.webp": 52133,
	"./Suzuki_Hayabusa.webp": 33381,
	"./Suzuki_Hayabusa_mobile.webp": 57236,
	"./Suzuki_Hayate.webp": 95623,
	"./Suzuki_Hayate_mobile.webp": 3662,
	"./Suzuki_Heat.webp": 69103,
	"./Suzuki_Heat_mobile.webp": 19094,
	"./Suzuki_Inazuma.webp": 33762,
	"./Suzuki_Inazuma_mobile.webp": 28649,
	"./Suzuki_Intruder.webp": 96286,
	"./Suzuki_Intruder_mobile.webp": 82757,
	"./Suzuki_Lets.webp": 98519,
	"./Suzuki_Lets_mobile.webp": 96606,
	"./Suzuki_Max.webp": 65545,
	"./Suzuki_Max_mobile.webp": 51192,
	"./Suzuki_Slingshot.webp": 44966,
	"./Suzuki_Slingshot_mobile.webp": 5197,
	"./Suzuki_Swish.webp": 52129,
	"./Suzuki_Swish_mobile.webp": 69552,
	"./Suzuki_V-Strom.webp": 10703,
	"./Suzuki_V-Strom_mobile.webp": 73526,
	"./Suzuki_Zeus.webp": 85744,
	"./Suzuki_Zeus_mobile.webp": 68679,
	"./TVS_Apache.webp": 45107,
	"./TVS_Apache_mobile.webp": 50858,
	"./TVS_Jupiter.webp": 58378,
	"./TVS_Jupiter_mobile.webp": 13361,
	"./TVS_Ntorq.webp": 98681,
	"./TVS_Ntorq_mobile.webp": 21608,
	"./TVS_Phoenix.webp": 52396,
	"./TVS_Phoenix_mobile.webp": 52115,
	"./TVS_Radeon.webp": 79118,
	"./TVS_Radeon_mobile.webp": 19669,
	"./TVS_Raider.webp": 18118,
	"./TVS_Raider_mobile.webp": 85453,
	"./TVS_Ronin.webp": 10271,
	"./TVS_Ronin_mobile.webp": 71142,
	"./TVS_Scooty.webp": 45670,
	"./TVS_Scooty_mobile.webp": 35853,
	"./TVS_Sport.webp": 28185,
	"./TVS_Sport_mobile.webp": 95976,
	"./TVS_Star City.webp": 34164,
	"./TVS_Star City_mobile.webp": 23675,
	"./TVS_Victor.webp": 32522,
	"./TVS_Victor_mobile.webp": 63569,
	"./TVS_Wego.webp": 11967,
	"./TVS_Wego_mobile.webp": 51014,
	"./TVS_XL.webp": 36069,
	"./TVS_XL_mobile.webp": 54324,
	"./Tata_Altroz.webp": 9224,
	"./Tata_Altroz_mobile.webp": 60767,
	"./Tata_Aria.webp": 6179,
	"./Tata_Aria_mobile.webp": 32282,
	"./Tata_Bolt.webp": 55457,
	"./Tata_Bolt_mobile.webp": 36496,
	"./Tata_Harrier.webp": 17619,
	"./Tata_Harrier_mobile.webp": 23722,
	"./Tata_Hexa.webp": 38890,
	"./Tata_Hexa_mobile.webp": 47025,
	"./Tata_Indica V2.webp": 52114,
	"./Tata_Indica V2_mobile.webp": 91897,
	"./Tata_Indica Vista.webp": 12167,
	"./Tata_Indica Vista_mobile.webp": 39854,
	"./Tata_Indica eV2.webp": 70121,
	"./Tata_Indica eV2_mobile.webp": 43320,
	"./Tata_Indica.webp": 94374,
	"./Tata_Indica_mobile.webp": 14221,
	"./Tata_Indigo CS.webp": 32718,
	"./Tata_Indigo CS_mobile.webp": 20021,
	"./Tata_Indigo Marina.webp": 26050,
	"./Tata_Indigo Marina_mobile.webp": 8649,
	"./Tata_Indigo XL.webp": 51432,
	"./Tata_Indigo XL_mobile.webp": 73087,
	"./Tata_Indigo eCS.webp": 94885,
	"./Tata_Indigo eCS_mobile.webp": 34644,
	"./Tata_Indigo.webp": 28564,
	"./Tata_Indigo_mobile.webp": 30395,
	"./Tata_Manza.webp": 95279,
	"./Tata_Manza_mobile.webp": 61750,
	"./Tata_Nano Genx.webp": 61982,
	"./Tata_Nano Genx_mobile.webp": 52389,
	"./Tata_Nano.webp": 55212,
	"./Tata_Nano_mobile.webp": 49075,
	"./Tata_Nexon.webp": 80052,
	"./Tata_Nexon_mobile.webp": 97211,
	"./Tata_Punch.webp": 55642,
	"./Tata_Punch_mobile.webp": 71585,
	"./Tata_Safari Storme.webp": 3518,
	"./Tata_Safari Storme_mobile.webp": 83813,
	"./Tata_Safari.webp": 60106,
	"./Tata_Safari_mobile.webp": 50705,
	"./Tata_Sumo Gold.webp": 32344,
	"./Tata_Sumo Gold_mobile.webp": 79311,
	"./Tata_Sumo Grande MK II.webp": 54033,
	"./Tata_Sumo Grande MK II_mobile.webp": 41088,
	"./Tata_Sumo Grande.webp": 60623,
	"./Tata_Sumo Grande_mobile.webp": 2326,
	"./Tata_Sumo Spacio.webp": 39921,
	"./Tata_Sumo Spacio_mobile.webp": 5120,
	"./Tata_Sumo Victa.webp": 42691,
	"./Tata_Sumo Victa_mobile.webp": 79738,
	"./Tata_Tiago NRG.webp": 88871,
	"./Tata_Tiago NRG_mobile.webp": 32654,
	"./Tata_Tiago.webp": 57442,
	"./Tata_Tiago_mobile.webp": 33193,
	"./Tata_Tigor.webp": 25791,
	"./Tata_Tigor_mobile.webp": 93030,
	"./Tata_Venture.webp": 96041,
	"./Tata_Venture_mobile.webp": 39288,
	"./Tata_Winger.webp": 49870,
	"./Tata_Winger_mobile.webp": 17141,
	"./Tata_Xenon.webp": 41144,
	"./Tata_Xenon_mobile.webp": 16047,
	"./Tata_Zest.webp": 11408,
	"./Tata_Zest_mobile.webp": 94119,
	"./Toyota_Alphard.webp": 75162,
	"./Toyota_Alphard_mobile.webp": 55137,
	"./Toyota_Camry.webp": 8306,
	"./Toyota_Camry_mobile.webp": 92953,
	"./Toyota_Corolla Altis.webp": 13543,
	"./Toyota_Corolla Altis_mobile.webp": 27854,
	"./Toyota_Corolla.webp": 77840,
	"./Toyota_Corolla_mobile.webp": 61607,
	"./Toyota_Etios Cross.webp": 67174,
	"./Toyota_Etios Cross_mobile.webp": 65421,
	"./Toyota_Etios Liva.webp": 98796,
	"./Toyota_Etios Liva_mobile.webp": 40819,
	"./Toyota_Etios.webp": 65818,
	"./Toyota_Etios_mobile.webp": 91425,
	"./Toyota_Fortuner.webp": 5097,
	"./Toyota_Fortuner_mobile.webp": 17848,
	"./Toyota_Glanza.webp": 22605,
	"./Toyota_Glanza_mobile.webp": 16892,
	"./Toyota_Hilux.webp": 55812,
	"./Toyota_Hilux_mobile.webp": 61483,
	"./Toyota_Innova Crysta.webp": 84933,
	"./Toyota_Innova Crysta_mobile.webp": 63380,
	"./Toyota_Innova.webp": 52213,
	"./Toyota_Innova_mobile.webp": 38852,
	"./Toyota_Land Cruiser Prado.webp": 10794,
	"./Toyota_Land Cruiser Prado_mobile.webp": 9937,
	"./Toyota_Land Cruiser.webp": 1286,
	"./Toyota_Land Cruiser_mobile.webp": 3405,
	"./Toyota_Qualis.webp": 87223,
	"./Toyota_Qualis_mobile.webp": 96734,
	"./Toyota_Sera.webp": 96945,
	"./Toyota_Sera_mobile.webp": 50528,
	"./Toyota_Urban Cruiser Hyryder.webp": 42190,
	"./Toyota_Urban Cruiser Hyryder_mobile.webp": 95029,
	"./Toyota_Urban Cruiser.webp": 78523,
	"./Toyota_Urban Cruiser_mobile.webp": 48818,
	"./Toyota_Vellfire.webp": 29313,
	"./Toyota_Vellfire_mobile.webp": 39696,
	"./Toyota_Yaris.webp": 56664,
	"./Toyota_Yaris_mobile.webp": 96559,
	"./Triumph_Bonneville.webp": 25895,
	"./Triumph_Bonneville_mobile.webp": 3406,
	"./Triumph_Speed.webp": 67952,
	"./Triumph_Speed_mobile.webp": 25863,
	"./Triumph_Street.webp": 92138,
	"./Triumph_Street_mobile.webp": 80305,
	"./Triumph_Thunderbird.webp": 84682,
	"./Triumph_Thunderbird_mobile.webp": 43249,
	"./Triumph_Tiger.webp": 71336,
	"./Triumph_Tiger_mobile.webp": 7519,
	"./UM_Renegade.webp": 17643,
	"./UM_Renegade_mobile.webp": 21346,
	"./Vespa_Elegante.webp": 56802,
	"./Vespa_Elegante_mobile.webp": 36457,
	"./Vespa_LX.webp": 49031,
	"./Vespa_LX_mobile.webp": 39310,
	"./Vespa_S.webp": 55024,
	"./Vespa_SXL.webp": 5852,
	"./Vespa_SXL_mobile.webp": 6563,
	"./Vespa_S_mobile.webp": 47847,
	"./Vespa_VX.webp": 31281,
	"./Vespa_VXL.webp": 95819,
	"./Vespa_VXL_mobile.webp": 94082,
	"./Vespa_VX_mobile.webp": 92704,
	"./Vespa_ZX.webp": 70501,
	"./Vespa_ZX_mobile.webp": 42580,
	"./Volkswagen_Ameo.webp": 873,
	"./Volkswagen_Ameo_mobile.webp": 13784,
	"./Volkswagen_Beetle.webp": 51988,
	"./Volkswagen_Beetle_mobile.webp": 95003,
	"./Volkswagen_Cross Polo.webp": 94547,
	"./Volkswagen_Cross Polo_mobile.webp": 62282,
	"./Volkswagen_Jetta.webp": 36865,
	"./Volkswagen_Jetta_mobile.webp": 7856,
	"./Volkswagen_Passat.webp": 10255,
	"./Volkswagen_Passat_mobile.webp": 70070,
	"./Volkswagen_Polo.webp": 63603,
	"./Volkswagen_Polo_mobile.webp": 75946,
	"./Volkswagen_T-Roc.webp": 72812,
	"./Volkswagen_T-Roc_mobile.webp": 6515,
	"./Volkswagen_Taigun.webp": 34007,
	"./Volkswagen_Taigun_mobile.webp": 62110,
	"./Volkswagen_Tiguan.webp": 3519,
	"./Volkswagen_Tiguan_mobile.webp": 44710,
	"./Volkswagen_Vento.webp": 3449,
	"./Volkswagen_Vento_mobile.webp": 41736,
	"./Volkswagen_Virtus.webp": 84500,
	"./Volkswagen_Virtus_mobile.webp": 5307,
	"./Volvo_S40.webp": 6627,
	"./Volvo_S40_mobile.webp": 97850,
	"./Volvo_S60 Cross Country.webp": 78291,
	"./Volvo_S60 Cross Country_mobile.webp": 54282,
	"./Volvo_S60.webp": 87109,
	"./Volvo_S60_mobile.webp": 5652,
	"./Volvo_S80.webp": 35439,
	"./Volvo_S80_mobile.webp": 82326,
	"./Volvo_S90.webp": 21690,
	"./Volvo_S90_mobile.webp": 5313,
	"./Volvo_V40 Cross Country.webp": 43146,
	"./Volvo_V40 Cross Country_mobile.webp": 4049,
	"./Volvo_V40.webp": 81444,
	"./Volvo_V40_mobile.webp": 31979,
	"./Volvo_V60.webp": 7562,
	"./Volvo_V60_mobile.webp": 88561,
	"./Volvo_V90.webp": 70997,
	"./Volvo_V90_mobile.webp": 4868,
	"./Volvo_XC 40.webp": 96953,
	"./Volvo_XC 40_mobile.webp": 3304,
	"./Volvo_XC60.webp": 82297,
	"./Volvo_XC60_mobile.webp": 82824,
	"./Volvo_XC90.webp": 1110,
	"./Volvo_XC90_mobile.webp": 3293,
	"./Yamaha_Aerox.webp": 19498,
	"./Yamaha_Aerox_mobile.webp": 67921,
	"./Yamaha_Alpha.webp": 27937,
	"./Yamaha_Alpha_mobile.webp": 52528,
	"./Yamaha_FZ.webp": 35119,
	"./Yamaha_FZS.webp": 99455,
	"./Yamaha_FZS_mobile.webp": 80179,
	"./Yamaha_FZ_mobile.webp": 37782,
	"./Yamaha_Fascino.webp": 48824,
	"./Yamaha_Fascino_mobile.webp": 38127,
	"./Yamaha_Fazer.webp": 14519,
	"./Yamaha_Fazer_mobile.webp": 31902,
	"./Yamaha_MT.webp": 20366,
	"./Yamaha_MT_mobile.webp": 32597,
	"./Yamaha_RX.webp": 20165,
	"./Yamaha_Ray.webp": 91393,
	"./Yamaha_Ray_mobile.webp": 19664,
	"./Yamaha_SS.webp": 59565,
	"./Yamaha_SS_mobile.webp": 2076,
	"./Yamaha_SZ.webp": 89002,
	"./Yamaha_SZ_mobile.webp": 78801,
	"./Yamaha_Saluto.webp": 98757,
	"./Yamaha_Saluto_mobile.webp": 75380,
	"./Yamaha_YZF.webp": 65789,
	"./Yamaha_YZF_mobile.webp": 94993,
	"./Yezdi_Adventure.webp": 50091,
	"./Yezdi_Adventure_mobile.webp": 12418,
	"./Yezdi_Classic.webp": 84291,
	"./Yezdi_Classic_mobile.webp": 42970,
	"./Yezdi_Road King.webp": 54014,
	"./Yezdi_Road King_mobile.webp": 57029,
	"./Yezdi_Roadster.webp": 33219,
	"./Yezdi_Roadster_mobile.webp": 66618,
	"./Yezdi_Scrambler.webp": 69916,
	"./Yezdi_Scrambler_mobile.webp": 99011,
	"./basic-service.webp": 42231,
	"./basic-service_mobile.webp": 62174,
	"./bike-service-with-oil.webp": 26120,
	"./bike-service-with-oil_mobile.webp": 56703,
	"./bike-service.webp": 17402,
	"./bike-service_mobile.webp": 3937,
	"./car-running-repair.webp": 83139,
	"./car-running-repair_mobile.webp": 40186,
	"./comprehensive-service.webp": 8325,
	"./comprehensive-service_mobile.webp": 18932,
	"./running-repair.webp": 58410,
	"./running-repair_mobile.webp": 54289,
	"./standard-service.webp": 24298,
	"./standard-service_mobile.webp": 90193
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14799;